import { z } from 'zod';

// Main data source schema (camelCase for client use)
export const DataSourceSchema = z.object({
  id: z.number(),
  identifier: z.string(),
  name: z.string(),
  createdOn: z.coerce.date().nullable(),
  createdBy: z.number().nullable().optional(),
});

export type DataSourcesTableItem = z.infer<typeof DataSourceSchema>;
